import axios from '../../../../config/axios';
import { PaginatedOrdersResponse, SteelOrder } from './types';
import { Filter } from '../../../../components/SubHeaderFilter/types';

const API_BASE_URL = `${process.env.REACT_APP_GATEWAY_BASE_URL}/steel-orders`;
const ITEMS_PER_PAGE = 50;

interface FetchOrdersParams {
  pageParam?: number;
  filter: Filter[] | null;
  search?: string
}

export const fetchPaginatedOrders = async ({ pageParam = 1, filter, search }: FetchOrdersParams): Promise<PaginatedOrdersResponse> => {
  const params: any = {
    page: pageParam,
    limit: ITEMS_PER_PAGE,
    onlyActive: true,
  };

  if (filter && filter.length > 0) {
    params.filters = JSON.stringify(filter);
  }

  // Inserindo o search nos parâmetros caso ele exista
  if (search && search.trim() !== '') {
    params.search = search;
  }

  const { data } = await axios.get(`${API_BASE_URL}/order/paginated`, { params });
  return data;
};

export const updateSteelOrder = async (id: number, orderData: Partial<SteelOrder>): Promise<SteelOrder> => {
  try {
    const response = await axios.patch(`${API_BASE_URL}/order/${id}`, orderData);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar pedido:', error);
    throw error;
  }
};

export const deleteSteelOrder = async (id: number): Promise<{ message: string; deletedAt: string }> => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/order/${id}`);
    return response.data;
  } catch (error: any) {
    console.error('Erro ao excluir pedido:', error);
    throw error;
  }
};

export const closeSaleOrder = async (id: number): Promise<SteelOrder> => {
  try {
    const response = await axios.patch(`${API_BASE_URL}/order/${id}`, {
      status: true
    });
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
    }
    throw error;
  }
};

export const duplicateSteelOrder = async (id: number): Promise<SteelOrder> => {
  try {
    const response = await axios.post(`${API_BASE_URL}/order/${id}/duplicate`);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
    }
    throw error;
  }
};

export const getOrderColumns = async (): Promise<{ key: string; label: string }[]> => {
  const { data } = await axios.get(`${API_BASE_URL}/order/columns`);
  return data;
};

export { ITEMS_PER_PAGE };